import {FC, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {hideLoader} from 'app/redux/loaderSlice'
import {draftOrderTypes} from '../../models'
import CustomerAddressDialog from './CustomerAddressDialog'
import CustomerPhoneNumberDialog from './CustomerPhoneNumberDialog'
import {RootState} from 'setup'
import {formatPhoneNumber} from '../../helper'
import trim from 'lodash/trim'

type Props = {
  address: any
  title: string
  customerId?: any
  orderStatus?: any
  paymentMethodId?: string
}

const Address: FC<Props> = ({address, title, customerId, orderStatus, paymentMethodId}) => {
  const [showAddressDialog, setShowAddressDialog] = useState(false)
  const [showPhoneDialog, setShowPhoneDialog] = useState(false)
  const [updatedAddress, setUpdatedAddress] = useState(address)
  const order = useSelector<RootState>(({orders}) => orders.fulfillment.order) as any

  const dispatch = useDispatch()

  const handleShowAddressDialog = () => {
    setShowAddressDialog(true)
  }

  const handleCloseAddressDialog = () => {
    setShowAddressDialog(false)
    dispatch(hideLoader())
  }

  const handleShowPhoneDialog = () => {
    setShowPhoneDialog(true)
  }

  const handleClosePhoneDialog = (updatedPhone?: string) => {
    setShowPhoneDialog(false)
    if (updatedPhone) {
      setUpdatedAddress((prevAddress: any) => ({
        ...prevAddress,
        phone: updatedPhone,
      }))
    }
  }

  const isPhoneNumberHave = useMemo(() => {
    if (updatedAddress?.phone) {
      return true
    }
    let shippingPhone = order.order.shippingAddress?.phone
    if (trim(shippingPhone) === '') {
      shippingPhone = null
    }
    let customerPhone = order.order.customer?.phone
    if (trim(customerPhone) === '') {
      customerPhone = null
    }
    return !!shippingPhone || !!customerPhone
  }, [updatedAddress?.phone, order.order.shippingAddress?.phone, order.order.customer?.phone])

  return (
    <div className='d-flex flex-column'>
      <div className='d-flex align-items-center fs-5 fw-bolder mb-5 justify-content-between'>
        {title}
        {updatedAddress && (
          <>
            {orderStatus === draftOrderTypes.open && (
              <button
                id='btnCusAddEdit'
                className='btn btn-sm btn-link'
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_new_address'
                onClick={handleShowAddressDialog}
              >
                Change Address
              </button>
            )}
            {!isPhoneNumberHave && title === 'Shipping Address' && (
              <button
                id='btnEditPhone'
                className='btn btn-sm btn-link ms-3 text-primary'
                onClick={handleShowPhoneDialog}
              >
                Add Phone Number
              </button>
            )}
          </>
        )}
      </div>
      {updatedAddress && (
        <div className='fs-6 fw-bold text-gray-600'>
          {updatedAddress.addressLine1}
          <div>{updatedAddress.addressLine2}</div>
          <div>{`${updatedAddress.city}, ${updatedAddress.state.code} ${updatedAddress.zipCode}, ${updatedAddress.country.code}`}</div>
          <div className='mt-2'>
            {updatedAddress.phone && (
              <>
                <div className='fw-bolder mt-5'>Phone</div>
                <div className='text-gray-600'>
                  <span className='text-gray-600 text-hover-primary'>
                    {formatPhoneNumber(updatedAddress.phone)}
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {showAddressDialog && (
        <CustomerAddressDialog
          onClose={handleCloseAddressDialog}
          customerId={customerId}
          title={title}
          selectedAddress={updatedAddress.id}
          paymentMethodId={paymentMethodId}
        />
      )}
      {showPhoneDialog && (
        <CustomerPhoneNumberDialog
          onClose={handleClosePhoneDialog}
          addressId={updatedAddress.id}
          title='Add Phone Number'
          selectedPhone={updatedAddress.phone}
        />
      )}
    </div>
  )
}

export default Address
